// extracted by mini-css-extract-plugin
export default {"tariff":"formPayment_tariff__mYcIq","active":"formPayment_active__FKQYP","tariffNoAction":"formPayment_tariffNoAction__wFQ5G"};